import { DEFAULT_THEME_ID } from "./themes.js";
import { loadThemeSettings, saveThemePreset } from "./themeStore.js";

export const LIGHT_THEME_ID = "sand";
export const DARK_THEME_ID = DEFAULT_THEME_ID;

export function isDarkPreset(presetId) {
  return presetId === DARK_THEME_ID || presetId === "midnight" || presetId === "mono";
}

export async function toggleLightDark() {
  const current = await loadThemeSettings().catch(() => ({ presetId: DARK_THEME_ID }));
  const next = isDarkPreset(current.presetId) ? LIGHT_THEME_ID : DARK_THEME_ID;
  await saveThemePreset(next);
  return next;
}
